import React from 'react';
import { CheckIcon } from 'lucide-react';
import { CtaButton } from './CtaButton';
import { PRICE, PRICE_BEFORE } from '../data/ymparistooppi';
const recap = ['6 osaa', '5 bonusta', '240 sivua', '1.–6. luokka'];
const reassurances = ['Välitön digitaalinen lataus', 'Tulostusvalmiit PDF:t', '7 päivän tyytyväisyystakuu'];
export function FinalCta() {
  return <section className="relative w-full overflow-hidden bg-seyes px-8 py-24 sm:px-14 sm:py-32" data-id="element-109" data-mp="15fgialsjv51g">
      <div aria-hidden="true" className="pointer-events-none absolute inset-y-0 left-4 w-px bg-red-300 sm:left-8 lg:left-12" data-id="element-110" data-mp="1jb212b86wslf" />
      <div className="relative mx-auto max-w-3xl text-center" data-id="element-111" data-mp="1t2on72m2gc2y">
        <h2 className="font-serif text-[2.6rem] leading-[1.02] tracking-tight text-slate-900 sm:text-6xl" data-id="element-112" data-mp="1t251datap3jn">
          Ympäristöopin tuntisi voivat olla <em className="text-red-700" data-id="element-113" data-mp="22339o5arnx81">valmiiksi suunniteltuja jo tänään.</em>
        </h2>
        <p className="mx-auto mt-6 max-w-2xl text-lg leading-relaxed text-slate-900/75" data-id="element-114" data-mp="1x4tdbrdb2qku">
          Sen sijaan, että etsit ideoita, keksit jokaisen kokeen itse ja käytät sunnuntai-illat
          suunnitteluun, sinulla on selkeä paketti koko lukuvuodeksi. Enemmän aikaa sille, millä
          on oikeasti merkitystä:
        </p>
        <p className="mt-6 font-serif text-2xl italic leading-snug text-slate-900 sm:text-3xl" data-id="element-115" data-mp="x2qus8ojqblu">
          Oppilaasi. Opetuksesi. Elämäsi koulun ulkopuolella.
        </p>

        <ul className="mt-10 flex flex-wrap justify-center gap-x-6 gap-y-2 text-sm font-medium text-slate-900/70" data-id="element-116" data-mp="164qc723h3hpb">
          {recap.map(item => <li key={item} data-id="element-117" data-mp="1b2i6u3vi5hx7">{item}</li>)}
        </ul>

        <p className="mt-8 text-lg text-slate-900/60" data-id="element-118" data-mp="1fu9wmc6u3jma">Ennen <s data-id="element-119" data-mp="1fvl0sd46ytdx">{PRICE_BEFORE}</s></p>
        <p className="mt-2 font-serif text-6xl leading-none tracking-tight text-slate-900 sm:text-7xl" data-id="element-120" data-mp="1fwcufie8ah1k">{PRICE}</p>
        <p className="mt-3 text-sm text-slate-900/70" data-id="element-121" data-mp="1psfxqrktglq3">Kertamaksu – ei tilausta.</p>

        <div className="mt-8 flex justify-center" data-id="element-122" data-mp="1pqczjk9ifmaa">
          <CtaButton className="w-full sm:w-auto" data-id="element-123" data-mp="1tt9ijc2ypker" />
        </div>

        <ul className="mt-6 flex flex-wrap justify-center gap-x-6 gap-y-1.5 text-sm text-slate-900/70" data-id="element-124" data-mp="3quoxywqxuxpx">
          {reassurances.map(item => <li key={item} className="flex items-center gap-2" data-id="element-125" data-mp="3lwdowo8gwr8r">
              <CheckIcon className="h-4 w-4 text-red-700" aria-hidden="true" data-id="element-126" data-mp="3hl7jczm4of9" />
              {item}
            </li>)}
        </ul>
      </div>
    </section>;
}